import user_api from '@/api/user';
import { request_list } from '@/commons/hpod';
import moment from 'moment';
import Vue from 'vue';

const state = {
    date_range: [],
    period_date: [],
    compare_date: false,
    allowCompare: false,
    start_time: undefined,
    end_time: undefined,
    compare_start_time: undefined,
    compare_end_time: undefined,
    rangeSelect: '',
    rangeSelectCompare: '',
    all_users: [],
    provinces: [],
    districts: [],
    airports: [],
    seaports: [],
    ships: [],
    sidebarExpanded: true,
    orderWidgets: {
        customer: true,
        staff: true,
        product: true,
        chat: true,
        paymentHistory: false,
        paymentArea: true,
        complain: false,
        changeHistory: false,
        transaction: true,
    },
    filters: {
        "user_list": [],
        "customer_list": [],
        "supplier_list": [],
        "service_list": [],
        "route_list": [],
        "container_list": [],
        "ship_list": [],
        "airport_list": [],
        "seaport_list": [],
        "province_list": [],
        "district_list": [],
        "commune_list": [],
        "fee_general_list": [],
        "fee_cost_list": [],
        "fee_revenue_list": [],
        "order_list": [],
        "payonbehalf_list": [],
        "payonbehalf_servicelist": [],
        "get_sale_monthly_report": [],
        "dnhu-delay": [],
        "hu-delay": [],
        "tu-delay": [],
    },
    filterConditions: {
        "user_list": [],
        "customer_list": [],
        "supplier_list": [],
        "service_list": [],
        "route_list": [],
        "container_list": [],
        "ship_list": [],
        "airport_list": [],
        "seaport_list": [],
        "province_list": [],
        "district_list": [],
        "commune_list": [],
        "fee_general_list": [],
        "fee_cost_list": [],
        "fee_revenue_list": [],
        "order_list": [],
        "payonbehalf_list": [],
        "payonbehalf_servicelist": [],
        "get_sale_monthly_report": [],
        "dnhu-delay": [],
        "hu-delay": [],
        "tu-delay": [],
    }
};

const getters = {};

const actions = {
    getAllUsers({ commit }) {
        user_api.getAllUsers(res => {
            commit('setAllUsers', res);
        }, Vue.http, this.state.authentication.token);
    },
    getProvinces({ commit }){
        request_list('provinces', data => {
            commit('setProvinces', data);
        }, Vue.http, {}, this.state.authentication.token);
    },
    getDistricts({ commit }){
        request_list('districts', data => {
            commit('setDistricts', data);
        }, Vue.http, {}, this.state.authentication.token);
    },
    getAirPorts({ commit }){
        request_list('airports', data => {
            commit('setAirPorts', data);
        }, Vue.http, {}, this.state.authentication.token);
    },
    getSeaPorts({ commit }){
        request_list('seaports', data => {
            commit('setSeaPorts', data);
        }, Vue.http, {}, this.state.authentication.token);
    },
    getShips({ commit }){
        request_list('ships', data => {
            commit('setShips', data);
        }, Vue.http, {}, this.state.authentication.token);
    },
    setDateRange({commit }, date_range_val) {
        commit('setDates', date_range_val);
    },
    setPeriodDates({commit }, date_range_val) {
        commit('setPeriodDates', date_range_val);
    },
    setCompareDate({commit }, compare_date_val) {
        commit('setCompareDate', compare_date_val);
    },
    setRangeSelect({commit }, rangeSelectVal) {
        commit('setRangeSelect', rangeSelectVal);
    },
    setRangeSelectCompare({commit }, rangeSelectCompareVal) {
        commit('setRangeSelectCompare', rangeSelectCompareVal);
    },
    setOrderWidgets({commit }, { widgets }) {
        commit('setOrderWidgets', { widgets });
    },
};

const mutations = {
    setAllUsers(state, res) {
        state.all_users = res.data || [];
    },
    setProvinces(state, res) {
        state.provinces = res.data || [];
    },
    setDistricts(state, res) {
        state.districts = res.data || [];
    },
    setAirPorts(state, res) {
        state.airports = res.data || [];
    },
    setSeaPorts(state, res) {
        state.seaports = res.data || [];
    },
    setShips(state, res) {
        state.ships = res.data || [];
    },
    setOrderWidgets(state, { widgets }) {
        state.orderWidgets = widgets;
    },
    setSidebarExpanded(state, { expanded }) {
        state.sidebarExpanded = expanded;
    },
    setFilters(state, { filter }) {
        state.filters = filter;
    },
    setFilterConditions(state, { filter }){
        state.filterConditions = filter;
    },
    setDates(state, date_range_val) {
        state.start_time = moment(date_range_val[0]).startOf('d').add(60 * moment().utcOffset(), 'seconds').unix();
        state.end_time = moment(date_range_val[1]).endOf('d').add(60 * moment().endOf('d').utcOffset(), 'seconds').unix();

        state.date_range = date_range_val;
    },
    setPeriodDates(state, val) {
        state.compare_start_time = moment(val[0]).startOf('d').add(60 * moment().utcOffset(), 'seconds').unix();
        state.compare_end_time = moment(val[1]).endOf('d').add(60 * moment().endOf('d').utcOffset(), 'seconds').unix();

        state.period_date = val;
    },
    setCompareDate(state, compare_date_val) {
        state.compare_date = compare_date_val;
        if(!compare_date_val){
            state.period_date = [];
            state.compare_start_time = null;
            state.compare_end_time = null;
        }
    },
    setRangeSelect(state, rangeSelectVal) {
        state.rangeSelect = rangeSelectVal;
    },
    setRangeSelectCompare(state, rangeSelectCompareVal) {
        state.rangeSelectCompare = rangeSelectCompareVal;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
